import React from 'react';
import { goToCheckout } from '../constants/checkout';
export function Footer() {
  return <>
      <section className="py-16 px-5 bg-wine text-white text-center" data-id="element-78">
        <div className="max-w-md mx-auto" data-id="element-79">
          <h2 className="text-2xl font-bold mb-8 leading-tight" data-id="element-80">
            Todas te dijeron que te dediques a esto. Ahora tenés el sistema para
            hacerlo. 🎀
          </h2>

          <div className="flex flex-col gap-3 mb-8" data-id="element-81">
            <button onClick={() => goToCheckout('base')} className="w-full h-[56px] bg-gold text-wine rounded-xl font-bold text-lg flex items-center justify-center gap-2 shadow-lg shadow-gold/20 active:scale-[0.98] transition-transform" data-id="element-82">
              <span data-id="element-83">🎀</span> Quiero Decora Fácil
            </button>
            <button onClick={() => goToCheckout('pro')} className="w-full h-[56px] bg-transparent border-2 border-white text-white rounded-xl font-bold text-[15px] flex items-center justify-center gap-2 active:bg-white/10 transition-colors" data-id="element-84">
              <span data-id="element-85">⭐</span> Quiero el Plan PRO/Élite
            </button>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-xs font-medium text-white/70" data-id="element-86">
            <div className="flex items-center gap-1" data-id="element-87">✅ Garantía 7 días</div>
            <div className="flex items-center gap-1" data-id="element-88">· 🔒 Pago seguro ·</div>
            <div className="flex items-center gap-1" data-id="element-89">⚡ Acceso inmediato</div>
          </div>
        </div>
      </section>

      <footer className="bg-wine-dark text-white/60 py-10 px-5 text-center text-sm" data-id="element-90">
        <div className="max-w-md mx-auto" data-id="element-91">
          <div className="font-bold text-white text-lg mb-3" data-id="element-92">
            🎀 Decora Fácil PRO™
          </div>
          <p className="mb-6 leading-relaxed" data-id="element-93">
            El sistema completo para decorar, organizar y cobrar tus eventos
            como una profesional, adaptado a la vida real en Argentina.
          </p>

          <div className="flex flex-wrap justify-center gap-4 mb-8 text-white/80" data-id="element-94">
            <a href="#" className="hover:text-white transition-colors" data-id="element-95">
              📧 hola@decorafacil.com
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-96">
              📱 @decorafacilpro
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-97">
              🌐 tusbeneficios.shop
            </a>
          </div>

          <div className="text-xs mb-4" data-id="element-98">
            © Decora Fácil PRO™ 2026 — Todos los derechos reservados.
          </div>

          <div className="italic text-pink-pastel/80" data-id="element-99">
            "De hobby a negocio, con el sistema que te faltaba."
          </div>
        </div>
      </footer>
    </>;
}